<template>
  <div class="formulate-input">
    <div class="formulate-input-wrapper">
      <label class="formulate-input-label">{{ field.label }}</label>
    </div>
    <div v-for="option in field.options" :key="option.key">
      <McRadioButton
        :id="option.key"
        v-model="computedOptions"
        :name="field.name"
        :initialValue="option.key"
        :label="`${option.label}`"
        class="mb-1"
      />
    </div>
  </div>
</template>
<script>
import McRadioButton from '@/components/McRadioButton'

export default {
  components: {
    McRadioButton
  },
  props: {
    value: {},
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['input'],
  computed: {
    computedOptions: {
      get: function () {
        if (this.value === '' || this.value === false) return null
        return this.value
      },
      set: function (newValue) {
        if (newValue === '' || newValue === false) {
          this.$emit('input', null)
          return
        }

        this.$emit('input', newValue)
      }
    }
  }
}
</script>
